import React, { useContext, useEffect, useState } from "react";
import EmployeeWorkHistory from "./EmployeeWorkHistory";
import TeamWorkSubmissions from "./TeamWorkSubmissions";
import { useActionsContext } from "../../context/ActionsContext";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import EmployeeLeaveHistory from "./EmployeeLeaveHistory";
import EmployeeMeetingHistory from "./EmployeemMeetingHistory";
import EmployeeLeaderboard from "./EmployeeLeaderboard";
import DefaultModal from "../../components/modals/DefaultModal";
import { Close, DeleteForever } from "@material-ui/icons";
import NoPermissionModal from "../../components/modals/NoPermissionModal";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import PermissionsManagement from "../security/PermissionsManagement";
import { connect } from "react-redux";
import Localbase from "localbase";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Stack, Typography } from "@mui/material";

const TeamMemberProfile = ({ value, dispatch }) => {
  const params = useParams();
  const { user } = useContext(AuthContext);
  const { permission } = useActionsContext();
  const internship_id = params.internship_id;
  const intern_id = params.user_id;
  const [edit, setEdit] = useState(false);
  const [member, setMember] = useState(null);
  const [teamMember, setTeamMember] = useState(null);
  const [internTasks, setInternTasks] = useState(null);
  const [section, setSection] = useState(
    JSON.parse(localStorage.getItem("team_section")) || "overview",
  );
  const [noPermission, setNoPermission] = useState(false);
  const [paySlips, setPaySlips] = useState([]);
  const [paySlipModal, setPaySlipModal] = useState(false);
  const [paySlipForm, setPaySlipForm] = useState({
    salary: "",
    working_days: "",
    normal_sick_leaves: "",
    additional_leaves: "",
  });
  const [paySlipLoading, setPaySlipLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [editPaySlip, setEditPaySlip] = useState(null);
  const [editPaySlipModal, setEditPaySlipModal] = useState(false);
  const [editPaySlipForm, setEditPaySlipForm] = useState({
    salary: "",
    working_days: "",
    normal_sick_leaves: "",
    additional_leaves: "",
    id: "",
  });
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [editPaySlipLoading, setEditPaySlipLoading] = useState(false);
  const [selectedPaySlipToDelete, setSelectedPaySlipToDelete] = useState(null);
  const [updateTeamMember, setUpdateTeamMember] = useState({
    designation: teamMember?.role || "",
    efficiency: teamMember?.efficiency || "",
    stipend: teamMember?.stipend || "",
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
  };

  const db = new Localbase("db");

  const fetchTeamMember = async () => {
    dispatch({ type: "LOADING" });
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("internship_id", internship_id);
    formData.append("intern_id", intern_id);
    try {
      const res = await axios.post(
        ENDPOINT + "team-member-profile.php",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (res?.data) {
        if (res.data.status === "success") {
          dispatch({ type: "DONE_LOADING" });
          setTeamMember(res.data.data);
          setMember(res.data.data);
          setUpdateTeamMember({
            designation: res.data.data.role,
            efficiency: res.data.data.efficiency,
            stipend: res.data.data.stipend || "",
          });
          db.collection("paths").add(
            { data: res.data.data },
            "team_member" + params.user_id,
          );
        } else {
          dispatch({
            type: "ERROR",
            payload: res.data.message || "Failed to fetch team member",
          });
        }
      } else {
        dispatch({ type: "ERROR", payload: "Invalid response format" });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload:
          error.message || "An error occurred while fetching team member",
      });
    }
  };

  const fetchInternTasks = async () => {
    dispatch({ type: "LOADING" });
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("status", "all");
    formData.append("internship_id", internship_id);
    formData.append("intern_id", intern_id);
    try {
      const res = await axios.post(
        ENDPOINT + "get-intern-tasks.php",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (res?.data) {
        if (res.data.status === "success") {
          dispatch({ type: "DONE_LOADING" });
          setInternTasks(res.data);
        } else {
          dispatch({
            type: "ERROR",
            payload: res.data.message || "Failed to fetch intern tasks",
          });
        }
      } else {
        dispatch({ type: "ERROR", payload: "Invalid response format" });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload:
          error.message || "An error occurred while fetching intern tasks",
      });
    }
  };

  const fetchPaySlips = async () => {
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("intern_id", intern_id); // Fixed: Use intern_id instead of internship_id
    try {
      const res = await axios.post(ENDPOINT + "get-pay-slips.php", formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        setPaySlips(res.data.data || []);
      } else {
        setSnackbar({
          open: true,
          message: res.data.message || "Failed to fetch pay-slips",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Failed to fetch pay-slips",
        severity: "error",
      });
    }
  };

  const handleAddPaySlip = async (e) => {
    e.preventDefault();
    setPaySlipLoading(true);
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("intern_id", intern_id); // Fixed: Use intern_id
    formData.append("salary", paySlipForm.salary);
    formData.append("working_days", paySlipForm.working_days);
    formData.append("normal_sick_leaves", paySlipForm.normal_sick_leaves);
    formData.append("additional_leaves", paySlipForm.additional_leaves);
    try {
      const res = await axios.post(ENDPOINT + "add-pay-slip.php", formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        setSnackbar({
          open: true,
          message: "Pay-slip added!",
          severity: "success",
        });
        setPaySlipModal(false);
        setPaySlipForm({
          salary: "",
          working_days: "",
          normal_sick_leaves: "",
          additional_leaves: "",
        });
        fetchPaySlips();
      } else {
        setSnackbar({
          open: true,
          message: res.data.message || "Failed to add pay-slip",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Error adding pay-slip",
        severity: "error",
      });
    } finally {
      setPaySlipLoading(false);
    }
  };

  const handleSaveProfile = async () => {
    const formData = new FormData();
    formData.append("internship_id", internship_id);
    formData.append("role", updateTeamMember.designation);
    formData.append("stipend", updateTeamMember.stipend);
    formData.append("efficiency", updateTeamMember.efficiency);
    try {
      const res = await axios.post(
        ENDPOINT + "update-team-member.php",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (res.data.status === "success") {
        setSnackbar({
          open: true,
          message: "Profile updated!",
          severity: "success",
        });
        setEdit(false);
        fetchTeamMember();
      } else {
        setSnackbar({
          open: true,
          message: res.data.message || "Update failed",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Error updating profile",
        severity: "error",
      });
    }
  };

  const handleDeletePaySlip = async (id) => {
    setPaySlipLoading(true);
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("id", id);
    try {
      const res = await axios.post(ENDPOINT + "delete-pay-slip.php", formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        // setSnackbar({
        //   open: true,
        //   message: "Pay-slip deleted!",
        //   severity: "success",
        // });
        fetchPaySlips();
        navigate(-1);
      } else {
        setSnackbar({
          open: true,
          message: res.data.message || "Failed to delete pay-slip",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Error deleting pay-slip",
        severity: "error",
      });
    } finally {
      setPaySlipLoading(false);
    }
  };

  const handleEditPaySlipOpen = (ps) => {
    setEditPaySlip(ps);
    setEditPaySlipForm({
      salary: ps.salary,
      working_days: ps.working_days,
      normal_sick_leaves: ps.normal_sick_leaves || "",
      additional_leaves: ps.additional_leaves || "",
      id: ps.id,
    });
    setEditPaySlipModal(true);
  };

  const handleEditPaySlipSubmit = async (e) => {
    e.preventDefault();
    setEditPaySlipLoading(true);
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("id", editPaySlipForm.id);
    formData.append("salary", editPaySlipForm.salary);
    formData.append("working_days", editPaySlipForm.working_days);
    formData.append("normal_sick_leaves", editPaySlipForm.normal_sick_leaves);
    formData.append("additional_leaves", editPaySlipForm.additional_leaves);
    try {
      const res = await axios.post(ENDPOINT + "update-pay-slip.php", formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        setSnackbar({
          open: true,
          message: "Pay-slip updated!",
          severity: "success",
        });
        setEditPaySlipModal(false);
        fetchPaySlips();
      } else {
        setSnackbar({
          open: true,
          message: res.data.message || "Failed to update pay-slip",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Error updating pay-slip",
        severity: "error",
      });
    } finally {
      setEditPaySlipLoading(false);
    }
  };

  const GetOfflineData = () => {
    db.collection("paths")
      .doc("team_member" + params.user_id)
      .get()
      .then((data) => {
        if (data) {
          setTeamMember(data.data);
        }
      });
  };

  useEffect(() => {
    GetOfflineData();
    fetchInternTasks();
    fetchTeamMember();
    fetchPaySlips();
  }, []);

  useEffect(() => {
    localStorage.setItem("team_section", JSON.stringify(section));
  }, [section]);

  useEffect(() => {
    if (value.functionName === "get-intern-tasks") {
      fetchInternTasks();
    }
  }, [value]);

  const ChangeSection = ({ team_section }) => {
    setSection(team_section);
  };

  return (
    <>
      <NoPermissionModal
        show={noPermission}
        HandleClose={() => setNoPermission(false)}
      />

      {teamMember ? (
        <>
          <DefaultModal
            show={edit}
            content={
              <>
                <div className="p-4">
                  <div className="modal-header">
                    <h4>Edit Profile</h4>
                    <Close onClick={() => setEdit(false)} />
                  </div>
                  <hr></hr>
                  <input
                    className="form-control"
                    value={updateTeamMember.designation}
                    placeholder="Enter Designation"
                    onChange={(e) =>
                      setUpdateTeamMember({
                        ...updateTeamMember,
                        designation: e.target.value,
                      })
                    }
                  ></input>
                  <input
                    className="form-control mt-2"
                    value={updateTeamMember.efficiency}
                    placeholder="efficiency"
                    onChange={(e) =>
                      setUpdateTeamMember({
                        ...updateTeamMember,
                        efficiency: e.target.value,
                      })
                    }
                    type="number"
                  ></input>
                  <input
                    className="form-control mt-2"
                    value={updateTeamMember.stipend}
                    placeholder="Stipend"
                    onChange={(e) =>
                      setUpdateTeamMember({
                        ...updateTeamMember,
                        stipend: e.target.value,
                      })
                    }
                    type="number"
                  ></input>

                  <button
                    className="btn btn-success w-100 mt-3"
                    onClick={handleSaveProfile}
                  >
                    Save Changes
                  </button>
                </div>
              </>
            }
          ></DefaultModal>
          <Modal open={open} onClose={() => setOpen(false)}>
            <Box sx={style}>
              <Typography variant="h6" mb={1}>
                Confirm Delete
              </Typography>

              <Typography variant="body2" color="text.secondary" mb={3}>
                Are you sure you want to delete?
              </Typography>

              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button variant="outlined" onClick={() => setOpen(false)}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() =>
                    handleDeletePaySlip(selectedPaySlipToDelete?.id)
                  }
                >
                  OK
                </Button>
              </Stack>
            </Box>
          </Modal>
          <div className="container-fluid">
            <div className="profile-foreground position-relative mx-n4 mt-n4">
              <div className="profile-wid-bg">
                <img
                  src="assets/images/profile-bg.jpg"
                  alt=""
                  className="profile-wid-img"
                />
              </div>
            </div>
            <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
              <div className="row g-4">
                <div className="col-auto">
                  <div className="avatar-lg">
                    <img
                      src={teamMember.profile_pic}
                      alt="user-img"
                      className="img-thumbnail rounded-circle"
                    />
                  </div>
                </div>
                {/*end col*/}
                <div className="col">
                  <div className="p-2">
                    <h3 className="text-white mb-1">
                      {teamMember
                        ? teamMember.first_name + " " + teamMember.last_name
                        : null}
                    </h3>
                    <p className="text-white text-opacity-75 mb-1">
                      {teamMember.role}
                    </p>
                    <div className="hstack text-white-50 gap-1">
                      <div className="me-2">
                        <i className=" me-1 text-white text-opacity-75 fs-16 align-middle" />
                        Employee ID :{teamMember.internship_id}
                      </div>
                    </div>
                  </div>
                </div>

                {/*end col*/}
              </div>
              {/*end row*/}
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div>
                  <div className="d-flex profile-wrapper">
                    {/* Nav tabs */}
                    <ul
                      className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                      role="tablist"
                    >
                      <li
                        onClick={() =>
                          ChangeSection({ team_section: "overview" })
                        }
                        className="nav-item"
                      >
                        <a className="nav-link fs-14 active" role="tab">
                          <i className="ri-airplay-fill d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Overview
                          </span>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          parseInt(permission.tasks)
                            ? ChangeSection({ team_section: "tasks" })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-list-unordered d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Tasks
                          </span>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          parseInt(permission.attendence)
                            ? ChangeSection({ team_section: "attendence" })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Attendance
                          </span>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          parseInt(permission.meetings)
                            ? ChangeSection({ team_section: "meetings" })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-price-tag-line d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Meetings
                          </span>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          parseInt(permission.leaves)
                            ? ChangeSection({ team_section: "leaves" })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-price-tag-line d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Leaves
                          </span>
                        </a>
                      </li>

                      <li
                        onClick={() => {
                          parseInt(permission.team_leaderboard)
                            ? ChangeSection({
                                team_section: "team_leaderboard",
                              })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-price-tag-line d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Team Leaderboard
                          </span>
                        </a>
                      </li>

                      <li
                        onClick={() => {
                          parseInt(permission.team_leaderboard)
                            ? ChangeSection({
                                team_section: "pay_slips",
                              })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-price-tag-line d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Pay Slips
                          </span>
                        </a>
                      </li>

                      <Link
                        onClick={() => {
                          parseInt(permission.team_permissions)
                            ? ChangeSection({
                                team_section: "team_permissions",
                              })
                            : setNoPermission(true);
                        }}
                        className="nav-item"
                      >
                        <a className="nav-link fs-14" role="tab">
                          <i className="ri-price-tag-line d-inline-block d-md-none" />{" "}
                          <span className="d-none d-md-inline-block">
                            Permissions
                          </span>
                        </a>
                      </Link>
                    </ul>
                    <div className="flex-shrink-0">
                      <button
                        onClick={() => {
                          parseInt(permission.initiate_placement_support)
                            ? setEdit(true)
                            : setNoPermission(true);
                        }}
                        className="btn btn-success"
                      >
                        <i className="ri-edit-box-line align-bottom" /> Edit
                        Profile
                      </button>
                    </div>
                  </div>
                  {/* Tab panes */}
                  <div className="tab-content pt-4 text-muted">
                    {section === "overview" ? (
                      <>
                        <div
                          className="tab-pane active"
                          id="overview-tab"
                          role="tabpanel"
                        >
                          <div className="row">
                            <div className="col-xxl-3">
                              <div className="card">
                                <div className="card-body">
                                  <h5 className="card-title mb-5">
                                    Effeciency
                                  </h5>
                                  <div className="progress animated-progress custom-progress progress-label">
                                    <div
                                      className="progress-bar bg-danger"
                                      role="progressbar"
                                      style={{
                                        width: `${teamMember.efficiency}%`,
                                      }}
                                      aria-valuenow={teamMember.efficiency}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    >
                                      <div className="label">
                                        {teamMember.efficiency}%
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-body">
                                  <h5 className="card-title mb-3">Info</h5>
                                  <div className="table-responsive h-fit">
                                    <table className="table table-borderless mb-0">
                                      <tbody>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            Name :
                                          </th>
                                          <td className="text-muted">
                                            {teamMember.last_name +
                                              " " +
                                              teamMember.last_name}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            Mobile :
                                          </th>
                                          <td className="text-muted">
                                            {teamMember.phone_number}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            E-mail :
                                          </th>
                                          <td className="text-muted">
                                            {teamMember.email}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            Location :
                                          </th>
                                          <td className="text-muted">
                                            {teamMember.address
                                              ? teamMember.address
                                              : "NA"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            Joining Date :
                                          </th>
                                          <td className="text-muted">
                                            {teamMember.joining_datetime}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                {/* end card body */}
                              </div>
                              {/* end card */}
                              <div className="card">
                                <div className="card-body">
                                  <h5 className="card-title mb-4">Portfolio</h5>
                                  <div className="d-flex flex-wrap gap-2">
                                    <div>
                                      <a
                                        href="javascript:void(0);"
                                        className="avatar-xs d-block"
                                      >
                                        <span className="avatar-title rounded-circle fs-16 bg-body text-body material-shadow">
                                          <i className="ri-github-fill" />
                                        </span>
                                      </a>
                                    </div>
                                    <div>
                                      <a
                                        href="javascript:void(0);"
                                        className="avatar-xs d-block"
                                      >
                                        <span className="avatar-title rounded-circle fs-16 bg-primary material-shadow">
                                          <i className="ri-global-fill" />
                                        </span>
                                      </a>
                                    </div>
                                    <div>
                                      <a
                                        href="javascript:void(0);"
                                        className="avatar-xs d-block"
                                      >
                                        <span className="avatar-title rounded-circle fs-16 bg-success material-shadow">
                                          <i className="ri-dribbble-fill" />
                                        </span>
                                      </a>
                                    </div>
                                    <div>
                                      <a
                                        href="javascript:void(0);"
                                        className="avatar-xs d-block"
                                      >
                                        <span className="avatar-title rounded-circle fs-16 bg-danger material-shadow">
                                          <i className="ri-pinterest-fill" />
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                {/* end card body */}
                              </div>
                              {/* end card */}
                              <div className="card">
                                <div className="card-body">
                                  <h5 className="card-title mb-4">Skills</h5>
                                  <div className="d-flex flex-wrap gap-2 fs-15">
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      Photoshop
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      illustrator
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      HTML
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      CSS
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      Javascript
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      Php
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      className="badge bg-primary-subtle text-primary"
                                    >
                                      Python
                                    </a>
                                  </div>
                                </div>
                                {/* end card body */}
                              </div>
                              {/* end card */}
                            </div>
                            {/*end col*/}
                            <div className="col-xxl-9">
                              <div className="card">
                                <div className="card-body">
                                  <h5 className="card-title mb-3">About</h5>
                                  <p>{teamMember.about}</p>

                                  <div className="row">
                                    <div className="col-6 col-md-4">
                                      <div className="d-flex mt-4">
                                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                          <div className="avatar-title bg-light rounded-circle fs-16 text-primary material-shadow">
                                            <i className="ri-user-2-fill" />
                                          </div>
                                        </div>
                                        <div className="flex-grow-1 overflow-hidden">
                                          <p className="mb-1">Designation :</p>
                                          <h6 className="text-truncate mb-0">
                                            {teamMember.role}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                    {/*end col*/}
                                  </div>
                                  {/*end row*/}
                                </div>
                                {/*end card-body*/}
                              </div>
                              {/* end card */}
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="card">
                                    <EmployeeWorkHistory />
                                  </div>

                                  {/* end card */}
                                </div>
                                {/* end col */}
                              </div>
                            </div>
                            {/*end col*/}
                          </div>
                          {/*end row*/}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {/*end tab-pane*/}
                    <div className="tab-pane active" id="tasks" role="tabpanel">
                      {section === "tasks" ? (
                        <>
                          {internTasks && internTasks.data ? (
                            <>
                              <TeamWorkSubmissions
                                item={teamMember}
                                tasks={internTasks.data}
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    {section === "attendence" ? (
                      <>
                        <div
                          className="tab-pane active"
                          id="attendance"
                          role="tabpanel"
                        >
                          <EmployeeWorkHistory />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {section === "meetings" ? (
                      <>
                        <div
                          className="tab-pane active"
                          id="leaves"
                          role="tabpanel"
                        >
                          <EmployeeMeetingHistory item={teamMember} />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {section === "leaves" ? (
                      <>
                        <div
                          className="tab-pane active"
                          id="leaves"
                          role="tabpanel"
                        >
                          <EmployeeLeaveHistory />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {section === "team_leaderboard" ? (
                      <>
                        {" "}
                        <div
                          className="tab-pane active"
                          id="leaderboard"
                          role="tabpanel"
                        >
                          <EmployeeLeaderboard />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {section === "team_permissions" ? (
                      <>
                        {" "}
                        <div
                          className="tab-pane active"
                          id="permissions"
                          role="tabpanel"
                        >
                          {permission &&
                          parseInt(permission.team_permissions) ? (
                            <PermissionsManagement
                              userid={member ? member.user_id : null}
                            />
                          ) : null}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {section === "pay_slips" ? (
                      <div
                        className="tab-pane bg-white p-3 rounded shadow-sm active mt-4"
                        id="pay-slips"
                        role="tabpanel"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5>Pay-Slips</h5>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setPaySlipModal(true)}
                          >
                            Add Pay-Slip
                          </Button>
                        </div>
                        {/* <div className="mb-3">
            <strong>Total Salary This Month: </strong>
            {(() => {
              const now = new Date();
              const month = now.getMonth() + 1;
              const year = now.getFullYear();
              const total = paySlips
                .filter(ps => {
                  if (!ps.date) return false;
                  const d = new Date(ps.date);
                  return d.getMonth() + 1 === month && d.getFullYear() === year;
                })
                .reduce((sum, ps) => {
                  const salary = parseFloat(ps.salary) || 0;
                  const workingDays = parseInt(ps.working_days) || 1;
                  const additionalLeaves = parseInt(ps.additional_leaves) || 0;
                  const perDaySalary = salary / workingDays;
                  const adjustedSalary = salary - (perDaySalary * additionalLeaves);
                  return sum + adjustedSalary;
                }, 0);
              return `₹ ${total.toFixed(2)}`;
            })()}
          </div> */}
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Salary Amount</th>
                                <th>Working Days</th>
                                <th>Normal/Sick Leaves</th>
                                <th>Additional Leaves</th>
                                <th>Adjusted Salary</th>
                                <th>Salary Per Day</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paySlips.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={8}
                                    className="text-center text-muted"
                                  >
                                    No pay-slips found.
                                  </td>
                                </tr>
                              ) : (
                                paySlips.map((ps, idx) => {
                                  const salary = parseFloat(ps.salary) || 0;
                                  const workingDays =
                                    parseInt(ps.working_days) || 1;
                                  const additionalLeaves =
                                    parseInt(ps.additional_leaves) || 0;
                                  const perDaySalary = salary / workingDays;
                                  const adjustedSalary =
                                    salary - perDaySalary * additionalLeaves;
                                  return (
                                    <tr key={idx}>
                                      <td>{ps.date || "-"}</td>
                                      <td>₹ {salary.toFixed(2)}</td>
                                      <td>{ps.working_days}</td>
                                      <td>{ps.normal_sick_leaves || "0"}</td>
                                      <td>{ps.additional_leaves || "0"}</td>
                                      <td>₹ {adjustedSalary.toFixed(2)}</td>
                                      <td>₹ {perDaySalary.toFixed(2)}</td>
                                      <td>
                                        <Button
                                          size="small"
                                          color="primary"
                                          onClick={() =>
                                            handleEditPaySlipOpen(ps)
                                          }
                                          startIcon={<EditIcon />}
                                        >
                                          Edit
                                        </Button>
                                        <Button
                                          size="small"
                                          color="error"
                                          onClick={() => {
                                            setSelectedPaySlipToDelete(ps);
                                            setOpen(true);
                                          }}
                                          startIcon={<DeleteIcon />}
                                        >
                                          Delete
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                        <Dialog
                          open={paySlipModal}
                          onClose={() => setPaySlipModal(false)}
                          maxWidth="xs"
                          fullWidth
                        >
                          <DialogTitle>Add Pay-Slip</DialogTitle>
                          <DialogContent>
                            <form
                              id="add-pay-slip-form"
                              onSubmit={handleAddPaySlip}
                            >
                              <div className="mb-3">
                                <label className="form-label">
                                  Salary Amount (₹)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={paySlipForm.salary}
                                  onChange={(e) =>
                                    setPaySlipForm({
                                      ...paySlipForm,
                                      salary: e.target.value,
                                    })
                                  }
                                  required
                                  min="0"
                                  step="0.01"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Number of Working Days
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={paySlipForm.working_days}
                                  onChange={(e) =>
                                    setPaySlipForm({
                                      ...paySlipForm,
                                      working_days: e.target.value,
                                    })
                                  }
                                  required
                                  min="1"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Normal/Sick Leaves
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={paySlipForm.normal_sick_leaves}
                                  onChange={(e) =>
                                    setPaySlipForm({
                                      ...paySlipForm,
                                      normal_sick_leaves: e.target.value,
                                    })
                                  }
                                  min="0"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Additional Leaves
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={paySlipForm.additional_leaves}
                                  onChange={(e) =>
                                    setPaySlipForm({
                                      ...paySlipForm,
                                      additional_leaves: e.target.value,
                                    })
                                  }
                                  min="0"
                                />
                              </div>
                            </form>
                            <div className="mb-2">
                              <strong>Salary Per Day: </strong>
                              {paySlipForm.salary && paySlipForm.working_days
                                ? `₹ ${(parseFloat(paySlipForm.salary) / parseInt(paySlipForm.working_days)).toFixed(2)}`
                                : "-"}
                            </div>
                            <div className="mb-2">
                              <strong>Adjusted Salary: </strong>
                              {paySlipForm.salary &&
                              paySlipForm.working_days &&
                              paySlipForm.additional_leaves !== ""
                                ? `₹ ${(parseFloat(paySlipForm.salary) - (parseFloat(paySlipForm.salary) / parseInt(paySlipForm.working_days)) * parseInt(paySlipForm.additional_leaves || 0)).toFixed(2)}`
                                : "-"}
                            </div>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => setPaySlipModal(false)}
                              color="secondary"
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              form="add-pay-slip-form"
                              variant="contained"
                              color="primary"
                              disabled={paySlipLoading}
                            >
                              {paySlipLoading ? "Saving..." : "Save"}
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Dialog
                          open={editPaySlipModal}
                          onClose={() => setEditPaySlipModal(false)}
                          maxWidth="xs"
                          fullWidth
                        >
                          <DialogTitle>Edit Pay-Slip</DialogTitle>
                          <DialogContent>
                            <form
                              id="edit-pay-slip-form"
                              onSubmit={handleEditPaySlipSubmit}
                            >
                              <div className="mb-3">
                                <label className="form-label">
                                  Salary Amount (₹)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editPaySlipForm.salary}
                                  onChange={(e) =>
                                    setEditPaySlipForm({
                                      ...editPaySlipForm,
                                      salary: e.target.value,
                                    })
                                  }
                                  required
                                  min="0"
                                  step="0.01"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Number of Working Days
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editPaySlipForm.working_days}
                                  onChange={(e) =>
                                    setEditPaySlipForm({
                                      ...editPaySlipForm,
                                      working_days: e.target.value,
                                    })
                                  }
                                  required
                                  min="1"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Normal/Sick Leaves
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editPaySlipForm.normal_sick_leaves}
                                  onChange={(e) =>
                                    setEditPaySlipForm({
                                      ...editPaySlipForm,
                                      normal_sick_leaves: e.target.value,
                                    })
                                  }
                                  min="0"
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Additional Leaves
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editPaySlipForm.additional_leaves}
                                  onChange={(e) =>
                                    setEditPaySlipForm({
                                      ...editPaySlipForm,
                                      additional_leaves: e.target.value,
                                    })
                                  }
                                  min="0"
                                />
                              </div>
                            </form>
                            <div className="mb-2">
                              <strong>Salary Per Day: </strong>
                              {editPaySlipForm.salary &&
                              editPaySlipForm.working_days
                                ? `₹ ${(parseFloat(editPaySlipForm.salary) / parseInt(editPaySlipForm.working_days)).toFixed(2)}`
                                : "-"}
                            </div>
                            <div className="mb-2">
                              <strong>Adjusted Salary: </strong>
                              {editPaySlipForm.salary &&
                              editPaySlipForm.working_days &&
                              editPaySlipForm.additional_leaves !== ""
                                ? `₹ ${(parseFloat(editPaySlipForm.salary) - (parseFloat(editPaySlipForm.salary) / parseInt(editPaySlipForm.working_days)) * parseInt(editPaySlipForm.additional_leaves || 0)).toFixed(2)}`
                                : "-"}
                            </div>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => setEditPaySlipModal(false)}
                              color="secondary"
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              form="edit-pay-slip-form"
                              variant="contained"
                              color="primary"
                              disabled={editPaySlipLoading}
                            >
                              {editPaySlipLoading ? "Saving..." : "Save"}
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Snackbar
                          open={snackbar.open}
                          autoHideDuration={4000}
                          onClose={() =>
                            setSnackbar({ ...snackbar, open: false })
                          }
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                        >
                          <MuiAlert
                            elevation={6}
                            variant="filled"
                            onClose={() =>
                              setSnackbar({ ...snackbar, open: false })
                            }
                            severity={snackbar.severity}
                            sx={{ width: "100%" }}
                          >
                            {snackbar.message}
                          </MuiAlert>
                        </Snackbar>
                      </div>
                    ) : null}
                    {/*end tab-pane*/}
                  </div>
                  {/*end tab-content*/}
                </div>
              </div>
              {/*end col*/}
            </div>
            {/*end row*/}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const reload = (prop) => ({
  value: prop.modalHandler,
});
export default connect(reload)(TeamMemberProfile);
